import * as yup from "yup";

function applyValidation(validator, { type, params }, validationType) {
  // Cross-field reference (e.g. confirm password)
  if (type === "refValue") {
    return validator.oneOf([yup.ref(params[0])], params[1]);
  }

  // Boolean oneOf — isTrue() avoids 1 !== true strict-equality mismatch
  if (type === "oneOf" && validationType === "boolean") {
    return validator.isTrue(params[1]);
  }

  if (!validator[type]) return validator;

  // oneOf expects ([allowedValues], message) — wrap scalar first param
  const resolvedParams =
    type === "oneOf" && !Array.isArray(params[0])
      ? [[params[0]], params[1]]
      : params;

  return validator[type](...resolvedParams);
}

export function createYupSchema(schema, config) {
  const { fieldId, validationType, validations } = config;

  if (!validations || !yup[validationType]) return schema;

  schema[fieldId] = validations.reduce(
    (v, validation) => applyValidation(v, validation, validationType),
    yup[validationType](),
  );

  return schema;
}
